import CheckNewOrders from "../symbols/checkNewOrdersArchived";
import { HttpRequestPost } from "../../service";

const checkNewOrdersArchivedAction = () => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_ARCHIVED,
});
const checkNewOrdersArchivedSuccessAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_ARCHIVED_SUCCESS,
  payload: data,
});
const checkNewOrdersArchivedFailureAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_ORDERS_ARCHIVED_FAILURE,
  payload: data,
});
const clearCheckNewOrdersAction = () => ({
  type: CheckNewOrders.CLEAR_CHECK_NEW_ORDERS_ARCHIVED,
});
export function getCheckNewOrdersArchived(
  Date: string,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    dispatch(checkNewOrdersArchivedAction());
    HttpRequestPost(
      "/order/check-new/archived",
      dispatch,
      checkNewOrdersArchivedSuccessAction,
      checkNewOrdersArchivedFailureAction,
      true,
      { Date },
      callback
    );
  };
}

export function clearCheckNewOrdersArchived() {
  return (dispatch: any) => {
    dispatch(clearCheckNewOrdersAction());
  };
}
